module.exports = __webpack_public_path__ + "media/images/application/default/default-justice-c6e5f1394500cc1b43285f7758b0c090.jpg";